<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps } from 'vue';
import CartaoBase from '@/components/v2/base/CartaoBase/CartaoBase.vue';
import CampoTextoBase from '@/components/v2/base/CampoTextoBase/CampoTextoBase.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({

    dado: {
        type: Object,
        default: () => ({})
    }

});

</script>

<template>

    <CartaoBase>

        <template #header>

            <div class="c-header">

                <span class="c-header__titulo">Job</span>

            </div>

        </template>

        <template #body>

            <div class="c-grid">

                <CampoTextoBase
                    label="Job"
                    :value="props?.dado?.job?.codigo"
                    disabled
                ></CampoTextoBase>

                <CampoTextoBase
                    label="Ordem de Serviço"
                    :value="props?.dado?.ordemDeServico?.codigo"
                    disabled
                ></CampoTextoBase>

            </div>

        </template>

    </CartaoBase>

</template>

<style scoped>

/*==================================================================*/
/*================== Header ========================================*/
/*==================================================================*/

.c-header {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: max-content;
}

.c-header__titulo {
    font-size: 1.25rem;
    font-weight: 700;
}

/*==================================================================*/
/*================== Grid ==========================================*/
/*==================================================================*/

.c-grid{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
}

@media (max-width: 768px) {
    .c-grid {
        display: grid;
        grid-template-columns: 1fr;
        grid-auto-rows: max-content;
    }
}

</style>
